import React from 'react';
import { useHistory, useLocation } from 'react-router';
import queryString from 'query-string';

// Constants
import QueryParamsConstants from 'Shared/constants/QueryParams.constants';

// Components
import ReviewTemplatePreviewContent from './ReviewTemplatePreviewContent';

const ReviewTemplatePreviewPage = () => {
  const history = useHistory();
  const location = useLocation();

  const { review_template_slug: reviewTemplateSlugFromParams } = queryString.parse(location.search);
  const { [QueryParamsConstants.CALLBACK_URL]: callbackUrl } = queryString.parse(location.search);

  const handleExitClick = () => {
    if (callbackUrl) {
      history.push({ pathname: callbackUrl, search: `?${QueryParamsConstants.SLUG}=${reviewTemplateSlugFromParams}` });
    } else {
      history.goBack();
    }
  };

  return (
    <ReviewTemplatePreviewContent
      reviewTemplateSlug={reviewTemplateSlugFromParams as string}
      handleExitClick={handleExitClick}
    />
  );
};

export default ReviewTemplatePreviewPage;
